import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import Navigation from "../../common/components/Navigation/Navigation";
import { getSelectedProjectGroup } from "../../features/projectGroups/state/projectGroupsSlice";
import CreateProjectGroupThumbnail from "./CreateProjectGroupThumbnail";

const EditProjectGroupThumbnailWrapper = () => {
  const { t } = useTranslation();

  const selectedProjectGroup = useSelector(getSelectedProjectGroup);

  return (
    <>
      <Navigation
        title={
          <>
            <span style={{ color: "black" }}>{t("pages.editProjectGroupName.title")} : </span>
            {` ${selectedProjectGroup.name}`}
          </>
        }
        isProjectGroupView={true}
      />
      <CreateProjectGroupThumbnail mode="edit" />
    </>
  );
};

export default EditProjectGroupThumbnailWrapper;
